import { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { Input, chakra } from "@chakra-ui/react";

function SearchLocationInput({ getAddress, getCoords, typeAnnonce, adr }) {
  const [adress, setAddress] = useState("");

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    setAddress(value);
    getAddress(results[0]);
    getCoords(latLng);
  };

  useEffect(() => {
    setAddress(adr);
  }, []);

  return (
    <Box>
      <PlacesAutocomplete
        value={adress}
        onChange={setAddress}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <Input
              borderRadius={"25px"}
              fontSize={"14px"}
              fontFamily={"Sofia Pro"}
              bg={"white"}
              {...getInputProps({
                placeholder: adr ? adr : `Lieu ${typeAnnonce}`,
              })}
            />
            <div>
              {loading ? <div> ...loading </div> : null}
              {suggestions.map((suggestion) => {
                const style = {
                  backgroundColor: suggestion.active ? "#41b6e6" : "#fff",
                };
                return (
                  <div {...getSuggestionItemProps(suggestion, { style })}>
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    </Box>
  );
}

export default SearchLocationInput;
